<template>
  <section>
    <form action v-on:submit.prevent="CreateDistribution">
      <div class="modal-card">
        <header class="modal-card-head">
          <p>Agregar Distribución</p>
        </header>
        <section class="modal-card-body">
          <b-loading :is-full-page="false" :active.sync="isLoading"></b-loading>
          <b-field label="Nombre" :label-position="'on-border'">
            <b-input v-model="distribution.name" required></b-input>
          </b-field>
        </section>
        <footer class="modal-card-foot">
          <button class="button" type="button" @click="$parent.close()">
            Cerrar
          </button>
          <button class="button is-primary" type="submit">Guardar</button>
        </footer>
      </div>
    </form>
  </section>
</template>
<script>
import { DistributionService } from "../../../../services/models/distribution";

export default {
  props: ["chargeListDistributions"],
  data() {
    return {
      distribution: {
        name: "",
      },
      isLoading: false,
    };
  },
  methods: {
    async CreateDistribution() {
      this.isLoading = true;
      try {
        await DistributionService.create(this.distribution);
        this.$buefy.notification.open({
          message: "Distribución Ingresada!",
          type: "is-success",
        });
        this.chargeListDistributions();
        this.isLoading = false;
        this.$parent.close();
      } catch (error) {
        this.isLoading = false;
        this.$buefy.notification.open({
          message: "Error al ingresar distribución!",
          type: "is-success",
        });
      }
    },
  },
};
</script>